import { useState } from 'react';
import styles from './search.module.scss';
import { IoCloseSharp, IoSearch } from 'react-icons/io5';
import { Box, TextField, InputAdornment } from '@mui/material';

type Props = {
  search?: string;
  setSearch?: (value: string) => void;
};
export default function SearchImput({ search = '', setSearch }: Props) {
  const [searchVal, setSearchVal] = useState('');
  const handleKey = (event: any) => {
    if (event.key === 'Enter') {
      setSearch?.(searchVal)
    }
  }
  const handleChange = (event: any) => {
    setSearchVal(event.target.value)
  }
  const handleClear = () => setSearch?.('');

  return (
    <Box className={styles.search}>
      <TextField
        sx={{
          '.MuiInputBase-input': {
            padding: '0',
          },
          '.MuiInputBase-root': {
            color: '#000',
            fontSize: '16px',
            height: '38px',
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
        id='search'
        autoComplete='off'
        value={searchVal}
        onKeyUp={handleKey}
	onChange={handleChange}
        className={styles.autocomplete}
        placeholder='Поиск'
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              {search?.length > 0 ? (
                <IoCloseSharp className={styles.clearIcon} onClick={handleClear} />
              ) : (
                <IoSearch />
              )}
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
